/**
 * Centralized tracking abstraction layer that provides specific tracking methods for different analytics providers.
 *
 * NOTE: Not all registration flow steps are tracked here because we already track some of them in the backend:
 * - Parent registration step completed - "TrackRegistrationAsync" in Amplitude.cs
 * - Parent sign in - "TrackSignInAsync" in Amplitude.cs
 * - Buy membership step completed - "TrackPurchaseCompletedAsync" in Amplitude.cs
 */

import Amplitude from "./Amplitude";

export class Tracking {
	/**
	 * Tracks the start for our registration flow.
	 * Fires at the start of the first step of the registration flow.
	 */
	public static TrackRegistrationStarted(hasRegisterParentStep: boolean, productType?: string): void {
		Amplitude.track({
			eventType: "Registration Started",
			eventProperties: {
				// Flow type is the type of registration flow a parent is undertaking.
				flowType: hasRegisterParentStep ? "IncludesParentRegistration" : "ParentWasAlreadyRegistered",
				...(productType !== undefined && { productType }),
			},
		});
	}

	/**
	 * Tracks the completion of a student registration step.
	 * Fires at the end of the second step of the registration flow.
	 */
	public static TrackStudentRegistrationStepCompleted(): void {
		Amplitude.track({
			eventType: "Student Account Step Completed",
		});
	}

	/**
	 * Tracks the completion of a student account configuration step.
	 * Fires at the end of the third step of the registration flow.
	 */
	public static TrackStudentConfigureAccountStepCompleted(initializationGrade: string, communityFeatureLevel: string): void {
		Amplitude.track({
			eventType: "Student Configure Account Step Completed",
			eventProperties: {
				initializationGrade: initializationGrade,
				communityFeatureLevel: communityFeatureLevel,
			},
		});
	}
}
